import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useGrupoUsuarioList() {
  // Use toast
  const toast = useToast()

  const refGrupoListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: '#' },
    { key: 'nome', sortable: true, label: 'Nome Cliente' },
    { key: 'tipo_pessoa', sortable: true, label: 'Tipo Pessoa' },
    { key: 'documento', sortable: true, label: 'Documento' },
    { key: 'ativo', sortable: true, label: 'Status' },
    { key: 'data_inclusao', sortable: true, label: 'Data criação' },
    { key: 'actions', label: 'Ações' },
  ]
  const perPage = ref(10)
  const totalClientes = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 15, 20, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref('')
  const tipoPessoaFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refGrupoListTable.value ? refGrupoListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalClientes.value,
    }
  })

  const refetchData = () => {
    refGrupoListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const getStatus = status => {
    let alterStatus = null
    if (['1', 1, 'active', 'ativo', true, 'true'].indexOf(status) !== -1) {
      alterStatus = 1
    }
    if (['0', 0, 'inactive', 'inativo', false, 'false'].indexOf(status) !== -1) {
      alterStatus = 0
    }
    return alterStatus
  }

  const fetchCleintes = (ctx, callback) => {
    store
      .dispatch('appAdmCliente/fetchCleintes', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        ativo: getStatus(statusFilter.value) || null,
        tipo_pessoa: tipoPessoaFilter.value,
      })
      .then(response => {
        const { clientes, total } = response.data

        callback(clientes)
        totalClientes.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Algo deu errado',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveGrupoUsuarioVariante = role => {
    if (role === 'Admin B2B') return 'primary'
    if (role === 'Cliente B2B') return 'warning'
    if (role === 'Admin') return 'danger'
    return 'primary'
  }

  const resolveGrupoUsuarioIcon = role => {
    if (role === 'Cliente B2B') return 'UserIcon'
    if (role === 'Admin B2B') return 'SettingsIcon'
    if (role === 'Admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === null) return 'warning'
    if (status === 1) return 'success'
    if (status === 0) return 'danger'
    return 'primary'
  }

  return {
    fetchCleintes,
    tableColumns,
    perPage,
    currentPage,
    totalClientes,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refGrupoListTable,

    resolveGrupoUsuarioVariante,
    resolveGrupoUsuarioIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    statusFilter,
    tipoPessoaFilter,
  }
}
